// Admin → 라이선스 — Business Pro plan card + seat usage + billing history.
import { I } from "../../../shared/Icon";
import { toast } from "../../../shared/stores/toasts";

const BILLING = [
  { d: "2026.05.15", title: "Business Pro · 5월",  seats: 92, amount: "₩4,840,000", state: "결제 완료" },
  { d: "2026.04.15", title: "Business Pro · 4월",  seats: 90, amount: "₩4,720,000", state: "결제 완료" },
  { d: "2026.03.15", title: "Business Pro · 3월",  seats: 89, amount: "₩4,656,000", state: "결제 완료" },
  { d: "2026.02.15", title: "Business Pro · 2월",  seats: 88, amount: "₩4,576,000", state: "결제 완료" },
  { d: "2026.01.15", title: "Business Pro · 1월",  seats: 85, amount: "₩4,420,000", state: "결제 완료" },
];

const FEATURES = [
  { ok: true,  l: "9개 ERP 모듈 전체" },
  { ok: true,  l: "C-Level BI 대시보드" },
  { ok: true,  l: "감사 로그 (90일 보관)" },
  { ok: true,  l: "백업 (일일 자동, 90일)" },
  { ok: true,  l: "SSO (SAML 2.0)" },
  { ok: true,  l: "API 호출 (월 500K)" },
  { ok: false, l: "전용 매니저 (Enterprise)" },
  { ok: false, l: "감사 로그 무제한 (Enterprise)" },
];

export function AdminLicense() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {/* ── Plan hero card ────────────────────────────────────────── */}
      <div
        className="t-card"
        style={{
          padding: 24,
          background: "linear-gradient(135deg, #4f4fb3 0%, #6E6FCF 50%, #9A9BE0 100%)",
          color: "white",
          borderColor: "transparent",
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: 20, flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ fontSize: 11.5, letterSpacing: "0.08em", fontWeight: 600, opacity: 0.85, textTransform: "uppercase" }}>
              현재 플랜
            </div>
            <div style={{ fontSize: 28, fontWeight: 800, marginTop: 4, letterSpacing: "-0.02em" }}>
              Business Pro
            </div>
            <div style={{ fontSize: 13, opacity: 0.85, marginTop: 4 }}>
              2026년 7월 15일까지 (52일 남음)
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button
              className="t-btn"
              style={{ background: "rgba(255,255,255,0.15)", color: "white", borderColor: "rgba(255,255,255,0.3)" }}
            >
              플랜 비교
            </button>
            <button
              className="t-btn"
              style={{ background: "white", color: "#5A5BB8", fontWeight: 700 }}
            >
              업그레이드
            </button>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 16, marginTop: 24 }}>
          {[
            { label: "월 청구 금액",  val: "₩4,840,000", sub: "₩52,000 × 92 좌석" },
            { label: "사용 좌석",     val: "92 / 100",   sub: "92% · 8석 남음" },
            { label: "스토리지",      val: "248 / 500 GB", sub: "49% 사용" },
            { label: "다음 결제일",   val: "06/15",      sub: "VISA •••• 4242" },
          ].map((s) => (
            <div key={s.label}>
              <div style={{ fontSize: 11, opacity: 0.7 }}>{s.label}</div>
              <div style={{ fontSize: 18, fontWeight: 700, marginTop: 3 }} className="num">{s.val}</div>
              <div style={{ fontSize: 11, opacity: 0.7, marginTop: 1 }}>{s.sub}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── 2-col: seat usage + features ─────────────────────────── */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
        <div className="t-card" style={{ padding: 20 }}>
          <h3 style={{ margin: "0 0 14px", fontSize: 14 }}>좌석 사용 현황</h3>
          <div style={{ height: 16, background: "var(--panel)", borderRadius: 8, overflow: "hidden", display: "flex" }}>
            <div style={{ flex: 81, background: "#16A34A" }} title="활성 81" />
            <div style={{ flex: 11, background: "#7C3AED" }} title="관리자 11" />
          </div>
          <div style={{ display: "flex", gap: 12, marginTop: 12, fontSize: 12, flexWrap: "wrap" }}>
            {[
              { c: "#16A34A", l: "활성 사용자", n: 81 },
              { c: "#7C3AED", l: "관리자",      n: 11 },
              { c: "var(--border-strong)", l: "남은 좌석", n: 8 },
            ].map((i) => (
              <div key={i.l} style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <span style={{ width: 8, height: 8, borderRadius: 2, background: i.c, flexShrink: 0 }} />
                {i.l} <span className="num" style={{ fontWeight: 600 }}>{i.n}</span>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 16 }}>
            <button className="t-btn t-btn-outline" style={{ width: "100%", justifyContent: "center" }}
              onClick={() => toast.info("준비 중", "좌석 추가 구매는 영업팀에 문의해 주세요")}>
              좌석 추가 구매
            </button>
          </div>
        </div>

        <div className="t-card" style={{ padding: 20 }}>
          <h3 style={{ margin: "0 0 14px", fontSize: 14 }}>플랜 포함 기능</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 8, fontSize: 12.5 }}>
            {FEATURES.map((f, i) => (
              <div
                key={i}
                style={{ display: "flex", alignItems: "center", gap: 6, color: f.ok ? "var(--text-2)" : "var(--text-3)" }}
              >
                {f.ok
                  ? <I.Check size={13} style={{ color: "var(--ok)", flexShrink: 0 }} />
                  : <I.X    size={13} style={{ flexShrink: 0 }} />}
                <span style={{ textDecoration: f.ok ? "none" : "line-through" }}>{f.l}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Billing history ───────────────────────────────────────── */}
      <div className="t-card" style={{ padding: 0, overflow: "auto" }}>
        <div style={{ padding: "12px 18px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center" }}>
          <strong style={{ fontSize: 13 }}>청구 내역</strong>
          <button className="t-btn" style={{ marginLeft: "auto", height: 28, fontSize: 11, color: "var(--p-600)" }}>
            전체 →
          </button>
        </div>
        <div
          style={{
            display: "flex", padding: "10px 18px",
            fontSize: 11, fontWeight: 600, color: "var(--text-3)",
            textTransform: "uppercase", letterSpacing: "0.06em",
            background: "var(--panel)",
          }}
        >
          <span style={{ width: 110 }}>청구일</span>
          <span style={{ flex: 1 }}>설명</span>
          <span style={{ width: 70 }}>좌석</span>
          <span style={{ width: 130, textAlign: "right" }}>금액</span>
          <span style={{ width: 80 }}>상태</span>
          <span style={{ width: 60 }} />
        </div>
        {BILLING.map((b, i) => (
          <div
            key={i}
            style={{
              display: "flex", padding: "12px 18px",
              borderTop: "1px solid var(--border)", fontSize: 13, alignItems: "center",
            }}
          >
            <span style={{ width: 110 }} className="mono">{b.d}</span>
            <span style={{ flex: 1 }}>{b.title}</span>
            <span style={{ width: 70 }} className="num">{b.seats}</span>
            <span style={{ width: 130, textAlign: "right", fontWeight: 600 }} className="num">{b.amount}</span>
            <span style={{ width: 80 }}>
              <span className="t-pill ok">{b.state}</span>
            </span>
            <span style={{ width: 60, textAlign: "right" }}>
              <button className="t-btn" style={{ height: 26, fontSize: 11, color: "var(--p-600)" }}>PDF</button>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
